// @flow
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react'
import { Dropdown } from 'react-bootstrap'

import { ANALYTICS_HELPER } from '../../../utils'

// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
	<a
		className="nav-link"
		href=""
		ref={ref}
		onClick={(e) => {
			e.preventDefault()
			ANALYTICS_HELPER._triggerEvent(ANALYTICS_HELPER.CATEGORY.NAVIGATION, {
				action: ANALYTICS_HELPER.EVENT.NAVIGATION.PROFILE_DROPDOWN.ACTION,
				label: ANALYTICS_HELPER.EVENT.NAVIGATION.PROFILE_DROPDOWN.LABEL,
				properties: {},
			})
			onClick(e)
		}}
	>
		{children}
	</a>
))

function AccountInfo(props) {
	const { username } = props
	return (
		<>
			<div className="account-dropdown">
				<Dropdown>
					<Dropdown.Toggle as={CustomToggle} id="account-dropdown-custom-components">
						<span className="text-default customerDetails">
							<span className="name-full">{username}</span>
							<span className="name-alias">{username}</span>
						</span>
					</Dropdown.Toggle>
				</Dropdown>
			</div>
		</>
	)
}

export default AccountInfo
